import Products from 'merchandise-lib/constants/Product';
import { DECEMBER_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS } from 'pricing-pages-ui-components/constants/PromotionKeys';
import { ENTERPRISE } from '../../../constants/routing/Tabs';
import { usePageParams } from '../../../hooks/usePageParams';
import { SCREENS } from '../../constants/tracking/Screens';
import { useProductPromotionIds } from '../pricing/useGrowthPurchaseOptions';
const STARTER_PRODUCT_API_NAME = Products.CRM_SUITE_STARTER_BUNDLE;

// Pages where the banner should be displayed
const INCLUDED_PAGES = [SCREENS.SUITE, SCREENS.MARKETING, SCREENS.SALES, SCREENS.SERVICE, SCREENS.DATA, SCREENS.CMS, SCREENS.CONTENT, SCREENS.FREE];
export const useStarterPromoDecember2025Banner = ({
  screen
}) => {
  const {
    tab
  } = usePageParams();
  const {
    promotionIds,
    loading: promotionIdsLoading,
    error: promotionIdsError
  } = useProductPromotionIds({
    productApiName: STARTER_PRODUCT_API_NAME
  });
  const eligibleForPromotion = DECEMBER_2025_NEW_CUSTOMER_STARTER_PROMOTION_KEYS.every(key => promotionIds.includes(key));
  const isValidScreenForPromo = INCLUDED_PAGES.includes(screen) && tab !== ENTERPRISE;
  const shouldShowBanner = Boolean(!promotionIdsLoading && eligibleForPromotion && isValidScreenForPromo && !promotionIdsError);
  return {
    shouldShowBanner,
    loading: promotionIdsLoading,
    error: promotionIdsError
  };
};